import React from 'react';
import { ErrorType, EveError } from '@ver-uds/e-verify';
import { Helmet } from 'react-helmet-async';

const NotFoundPage = (): JSX.Element => (
  <>
    <Helmet>
      <title>{ErrorType.NOT_FOUND}</title>
    </Helmet>

    <EveError errorType={ErrorType.NOT_FOUND} />
  </>
);

export default NotFoundPage;
